// Variant Radio Button Visual Handler
// Handles the visual selection states for product variant radio buttons

(function() {
  'use strict';
  
  function initVariantRadioHandler() {
    console.log('🔘 Initializing variant radio handler...');
    
    // Find all variant radio buttons
    const radioButtons = document.querySelectorAll('.product-header_radio input[type="radio"]');
    
    if (radioButtons.length === 0) {
      console.log('ℹ️ No variant radio buttons found');
      return;
    }
    
    console.log(`🔘 Found ${radioButtons.length} variant radio buttons`);
    
    // Add click handlers to all radio buttons
    radioButtons.forEach(radio => {
      // Handle both click and change events
      radio.addEventListener('change', handleRadioChange);
      radio.addEventListener('click', handleRadioClick);
      
      // Also handle clicks on the label
      const label = radio.closest('label');
      if (label) {
        label.addEventListener('click', (e) => {
          // Ensure the radio gets checked
          setTimeout(() => {
            if (!radio.checked) {
              radio.checked = true;
              handleRadioChange({ target: radio });
            }
          }, 10);
        });
      }
    });
    
    // Initialize visual states based on current selection
    updateAllVisualStates();
    
    console.log('✅ Variant radio handler initialized');
  }
  
  function handleRadioClick(e) {
    const radio = e.target;
    console.log('🔘 Radio clicked:', radio.name, '=', radio.value);
    
    // Small delay to ensure the radio state is updated
    setTimeout(() => {
      handleRadioChange(e);
    }, 10);
  }
  
  function handleRadioChange(e) {
    const radio = e.target;
    const optionName = radio.name;
    
    console.log('🔘 Radio changed:', optionName, '=', radio.value, 'checked:', radio.checked);
    
    // Update visual states for this option group
    updateVisualStatesForOption(optionName);
    
    // Update the variant ID based on all selected options
    updateVariantId();
    
    // Trigger variant selector update if it exists
    if (window.variantSelector && typeof window.variantSelector.updateVariant === 'function') {
      setTimeout(() => {
        window.variantSelector.updateVariant();
      }, 50);
    }
  }
  
  function updateVisualStatesForOption(optionName) {
    // Find all radio buttons for this option
    const optionRadios = document.querySelectorAll(`.product-header_radio input[name="${optionName}"]`);
    
    optionRadios.forEach(radio => {
      const label = radio.closest('label');
      if (!label) return;
      
      if (radio.checked) {
        // Add selected class
        label.classList.add('selected');
        console.log('🔘 Added selected class to:', radio.value);
      } else {
        // Remove selected class
        label.classList.remove('selected');
      }
    });
  }
  
  function updateAllVisualStates() {
    // Get all unique option names
    const optionNames = new Set();
    document.querySelectorAll('.product-header_radio input[type="radio"]').forEach(radio => {
      optionNames.add(radio.name);
    });
    
    // Update visual states for each option
    optionNames.forEach(optionName => {
      updateVisualStatesForOption(optionName);
    });
  }
  
  function updateVariantId() {
    // Get all selected options
    const selectedOptions = {};
    const checkedRadios = document.querySelectorAll('.product-header_radio input[type="radio"]:checked');
    
    checkedRadios.forEach(radio => {
      selectedOptions[radio.name] = radio.value;
    });
    
    console.log('🔘 Selected options:', selectedOptions);
    
    // Find the variant ID that matches these options
    const matchingRadio = findMatchingVariantRadio(selectedOptions);
    
    if (matchingRadio) {
      const variantId = matchingRadio.getAttribute('data-variant-id');
      if (variantId) {
        // Update the hidden variant ID input
        const variantIdInput = document.getElementById('product-variant-id');
        if (variantIdInput && variantIdInput.value !== variantId) {
          variantIdInput.value = variantId;
          variantIdInput.setAttribute('data-variant-id', variantId);
          
          // Trigger change event
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          
          console.log('🔘 Updated variant ID to:', variantId);
        }
      }
    }
  }
  
  function findMatchingVariantRadio(selectedOptions) {
    // Find a radio button that has a variant ID and matches our selection
    const allRadios = document.querySelectorAll('.product-header_radio input[type="radio"][data-variant-id]');
    
    for (const radio of allRadios) {
      const variantId = radio.getAttribute('data-variant-id');
      if (!variantId) continue;
      
      // Check if this radio's combination matches our selected options
      const radioOptions = {};
      
      // Get all radios with the same variant ID to build the option combination
      const sameVariantRadios = document.querySelectorAll(`[data-variant-id="${variantId}"]`);
      sameVariantRadios.forEach(r => {
        if (r.type === 'radio') {
          radioOptions[r.name] = r.value;
        }
      });
      
      // Check if this combination matches our selection
      const matches = Object.keys(selectedOptions).every(optionName => {
        return radioOptions[optionName] === selectedOptions[optionName];
      });
      
      if (matches) {
        return radio;
      }
    }
    
    return null;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantRadioHandler);
  } else {
    initVariantRadioHandler();
  }
  
  // Also initialize after a delay to catch any dynamically loaded content
  setTimeout(initVariantRadioHandler, 500);
  
  // Make functions available globally for debugging
  window.variantRadioHandler = {
    init: initVariantRadioHandler,
    updateVisualStates: updateAllVisualStates,
    updateVariantId: updateVariantId
  };
  
})();
